export default {
  getFieldNames(errors) {
    let fields;

    if (Array.isArray(errors)) {
      errors.forEach(itemErrors => {
        fields = {
          ...fields,
          ...this.getFieldsWithError(itemErrors)
        };
      });
    } else {
      fields = this.getFieldsWithError(errors);
    }

    return Object.keys(fields)
      .map(name => this.formatFieldName(name))
      .join(', ');
  },

  getFieldsWithError(data) {
    let fieldsWithError = {};

    Object.keys(data).forEach(function(key) {
      if (data[key]) {
        fieldsWithError[key] = data[key];
      }
    });

    return fieldsWithError;
  },

  formatFieldName(name) {
    return name.split('_').join(' ');
  }
};
